import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { SuperAdminGuard } from "@/src/admin/components/super-admin-guard";
import { ADMIN_ROUTES } from "@/src/admin/constants/admin-routes";

const withGuard = async (loader: () => Promise<{ default: React.ComponentType }>) => {
	const { default: Page } = await loader();
	const Guarded = () => (
		<SuperAdminGuard>
			<Page />
		</SuperAdminGuard>
	);
	return { Component: Guarded };
};

export const adminRouter: RouteObject = {
	children: [
		{
			path: ADMIN_ROUTES.ROOT,
			element: <Navigate to={ADMIN_ROUTES.VERSIONS} replace />,
		},
		{
			path: ADMIN_ROUTES.VERSIONS,
			lazy: () => withGuard(() => import("../pages/admin-versions-page")),
		},
		{
			path: ADMIN_ROUTES.CHANGELOGS,
			lazy: () => withGuard(() => import("../pages/admin-changelogs-page")),
		},
		{
			path: ADMIN_ROUTES.CHANGELOG_NEW,
			lazy: () => withGuard(() => import("../pages/admin-changelog-edit-page")),
		},
		{
			path: ADMIN_ROUTES.CHANGELOG_EDIT,
			lazy: () => withGuard(() => import("../pages/admin-changelog-edit-page")),
		},
		{
			path: ADMIN_ROUTES.BANNED_WORDS,
			lazy: () => withGuard(() => import("../pages/admin-banned-words-page")),
		},
		{
			path: ADMIN_ROUTES.MODERATION_EVENTS,
			lazy: () => withGuard(() => import("../pages/admin-moderation-events-page")),
		},
		{
			path: ADMIN_ROUTES.REPORTS,
			lazy: () => withGuard(() => import("../pages/admin-reports-page")),
		},
		{
			path: ADMIN_ROUTES.USERS,
			lazy: () => withGuard(() => import("../pages/admin-users-page")),
		},
	],
};
